import React, { Component } from 'react';

class GeckoLogoHeader extends Component {
    render() {
        return (
            <div className="header-logo">
                <img src="/images/gecko.svg" alt="Gecko Logo" className="w-[120px] h-auto" />
            </div>
        );
    }
}

export default GeckoLogoHeader;